<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>
<script>
import moment from 'moment';

import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('appraisalrecord.appraisalrecordlisting'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('columns.staffcode'), value: "staffcode", width: "200px" },
        { text: this.$t('columns.staffname'), value: "staffname", width: "200px" },
        { text: this.$t('columns.company'), value: "compnyname", width: "200px" },
        { text: this.$t('appraisalrecord.reviewtype'), value: "assessmenttypecode", width: "200px" },
        { text: this.$t('appraisalrecord.reviewfrom'), value: "startdate", width: "200px" },
        { text: this.$t('appraisalrecord.reviewuntil'), value: "enddate", width: "200px" },
        { text: this.$t('columns.status'), value: "pmstatusdesc", width: "200px" },
        { text: this.$t('Setuprankingset.rank'), value: "rankingdesc", width: "120px" },
        { text: this.$t('Setupratingscaleset.score'), value: "score", width: "150px" },
        { text: this.$t('appraisalrecord.adjustedrank'), value: "adjustedrankingdesc", width: "150px" },
        { text: this.$t('appraisalrecord.adjustedscore'), value: "adjustedscore", width: "150px" },

       
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
       search: this.$route.params.search,
    };
  },

  methods: {
    getRatingScaleSetHandler() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/appraisalrecord/all"})
        .then(function (res) {
          vm.dataItems = res.data.rec;

              for (let i = 0; i < vm.dataItems.length; i++) {
                    if (vm.dataItems[i].startdate) {
                        vm.dataItems[i].startdate = moment(vm.dataItems[i].startdate).format('YYYY-MM-DD');
                    }

                    if (vm.dataItems[i].enddate) {
                        vm.dataItems[i].enddate = moment(vm.dataItems[i].enddate).format('YYYY-MM-DD');
                    }
                 }

          vm.loading = !vm.loading;

        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "appraisalrecordedit", params: { id: item.id, search: item.search  } });
    },

    newRecordHandler() {
      this.$router.push({ name: "appraisalrecordnew" });
    },
  },

  mounted() {
    this.getRatingScaleSetHandler();
  },
};
</script>